import React, { useState, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';

interface PdfDropzoneProps {
    onFileSelect: (file: File) => void;
    uploadedFileName?: string | null;
    accept?: string;
    className?: string;
    uploadButtonLabel?: string;
}

export const PdfDropzone: React.FC<PdfDropzoneProps> = ({ 
    onFileSelect, 
    uploadedFileName,
    accept = "application/pdf",
    className = "",
    uploadButtonLabel = "Select from computer",
}) => {
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            onFileSelect(file);
        }
        // Reset input to allow same file selection
        if (event.target) {
            event.target.value = '';
        }
    };

    const handleDragEnter = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const file = e.dataTransfer.files?.[0];
        if (file) {
            onFileSelect(file);
        }
    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <div className={className}>
            <Form.Control
                type="file"
                ref={fileInputRef}
                accept={accept}
                onChange={handleFileUpload}
                style={{ display: 'none' }}
            />
            <div
                onClick={triggerFileInput}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                    border: isDragging ? '2px dashed #0d6efd' : '2px dashed #dee2e6',
                    borderRadius: '8px',
                    padding: '40px 20px',
                    textAlign: 'center',
                    backgroundColor: isDragging ? '#f8f9fa' : '#ffffff',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                }}
            >
                {uploadedFileName ? (
                    <div>
                        <i className="fa fa-file-pdf" style={{ fontSize: '48px', color: '#198754', marginBottom: '10px' }}></i>
                        <p className="mb-2" style={{ fontSize: '14px', color: '#6c757d' }}>
                            <strong>{uploadedFileName}</strong>
                        </p>
                        <p style={{ fontSize: '12px', color: '#6c757d' }}>
                            Click to change file
                        </p>
                    </div>
                ) : (
                    <div>
                        <i className="fa fa-cloud-upload-alt" style={{ fontSize: '48px', color: '#6c757d', marginBottom: '10px' }}></i>
                        <p className="mb-3" style={{ fontSize: '14px', color: '#6c757d' }}>
                            <strong>Drag and drop a pdf document</strong>
                            {' '}or
                        </p>
                        <Button 
                            variant="primary" 
                            onClick={(e) => {
                                e.stopPropagation();
                                triggerFileInput();
                            }}
                        >
                            {uploadButtonLabel}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PdfDropzone;

